import { createReducer, on } from "@ngrx/store";
import * as JWT from "jwt-decode";
import { TokenResponseModel } from "src/app/authenticator/models";
import { getFullAccessFailure, getFullAccessSuccess, loginLightFailure, loginLightSuccess, loginWithCertificateFailure, loginWithCertificateSuccess, resetAuthentication, setKioskSiteSuccess } from "./authentication.actions";

export const authenticationFeatureKey = "authentication";

export interface AuthenticationState {
	token: TokenResponseModel;
	fullTokenLoaded: boolean;
	kioskSiteInit: boolean;
}

export const initialState: AuthenticationState = {
	token: undefined,
	fullTokenLoaded: undefined,
	kioskSiteInit: false
};

export const authenticationReducer = createReducer(
	initialState,

	on(loginLightSuccess, (state, { data }) => ({
		...state,
		token: data,
	})),

	on(loginLightFailure, loginWithCertificateFailure, (state, { data }) => ({
		...state,
		token: null,
	})),

	on(getFullAccessSuccess, (state, { token }) => ({
		...state,
		token: token,
		fullTokenLoaded: true,
	})),
	on(getFullAccessFailure, (state, { data }) => ({
		...state,
		fullTokenLoaded: false,
	})),

	on(loginWithCertificateSuccess, (state, { data }) => ({
		...state,
		token: data,
	})),
	on(setKioskSiteSuccess, (state) => ({
		...state,
		kioskSiteInit: true
	})),
	on(resetAuthentication, () => initialState),
);
